import {
    PRODUCT_CREATE,
    PRODUCT_FETCH,
    PRODUCT_UPDATE,
    PRODUCT_PRICE_UPDATE,
} from '../actions/types';

const INITIAL_STATE = { 
    products: null,
    loading: false
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
        case PRODUCT_CREATE:
        case PRODUCT_UPDATE:
            return { ...state, loading: action.payload }
        case PRODUCT_PRICE_UPDATE:
            const products = [ ...state.products ]
            if (products !== null) {
                const index = products.findIndex(item => item.id === action.payload.id)
                products[index].price = action.payload.data.price
                products[index].price2 = action.payload.data.price2
                products[index].price3 = action.payload.data.price3
                products[index].price4 = action.payload.data.price4
            }
            return { ...state, products }
        case PRODUCT_FETCH:
            return { ...state, products: action.payload }
        default:
            return state
    }
}